<template>
  <div v-if="liveCasinoVisible" class="kplay-container">
    <div class="kplay-header" v-if="!gameUrl">
      <h2 class="kplay-title">라이브 카지노</h2>
      <div class="kplay-filter">
        <button
          v-for="vendor in vendors"
          :key="vendor.id"
          :class="['filter-btn', { active: selectedVendor === vendor.id }]"
          @click="selectedVendor = vendor.id"
        >
          {{ vendor.name }}
        </button>
      </div>
      <div class="kplay-search">
        <input
          type="text"
          v-model="searchQuery"
          placeholder="게임 검색..."
          class="search-input"
        />
      </div>
    </div>

    <div class="games-grid" v-if="!gameUrl">
      <div
        v-for="game in filteredGames"
        :key="game.product_id"
        class="game-card"
        @click="openGame(game)"
      >
        <div class="game-thumbnail">
          <img :src="game.img" :alt="game.name" />
          <div class="game-overlay">
            <button class="play-btn">플레이</button>
          </div>
        </div>
        <div class="game-info">
          <h3 class="game-name">{{ game.name }}</h3>
          <span class="game-vendor">{{ game.vendor }}</span>
        </div>
      </div>
    </div>

    <div v-if="filteredGames.length === 0 && !gameUrl" class="no-games">
      검색 결과가 없습니다.
    </div>

    <!-- Game Iframe -->
    <div v-if="gameUrl" class="game-iframe-container">
      <div class="game-iframe-header">
        <span class="game-title">{{ currentGameName }}</span>
        <button class="close-btn" @click="closeGame">✕ 닫기</button>
      </div>
      <iframe
        :src="gameUrl"
        class="game-iframe"
        frameborder="0"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "KplayLive",
  data() {
    return {
      searchQuery: '',
      selectedVendor: 'all',
      gameUrl: null,
      currentGameName: '',
      vendors: [
        { id: 'all', name: '전체' },
        { id: 'Evolution', name: '에볼루션' },
        { id: 'Big Gaming', name: '빅게이밍' },
        { id: 'Pragmatic', name: '프라그마틱' },
        { id: 'Sexy Gaming', name: '섹시게이밍' },
        { id: 'Micro', name: '마이크로' },
        { id: 'Dream Gaming', name: '드림게이밍' },
        { id: 'Ezugi', name: '에즈기' },
        { id: 'TVBet', name: 'TVBet' },
        { id: 'Skywind', name: '스카이윈드' },
      ],
      games: [
        { product_id: 1, name: '에볼루션', vendor: 'Evolution', img: require('@/assets/img/casino/evolution.jpg') },
        { product_id: 2, name: '빅게이밍', vendor: 'Big Gaming', img: require('@/assets/img/casino/big_gaming.jpg') },
        { product_id: 3, name: '마이크로게이밍', vendor: 'Micro', img: require('@/assets/img/casino/microgaming.jpg') },
        { product_id: 5, name: '플레이에이스', vendor: 'PlayAce', img: require('@/assets/img/casino/playace.jpg') },
        { product_id: 6, name: '드림게이밍', vendor: 'Dream Gaming', img: require('@/assets/img/casino/dreamgaming.jpg') },
        { product_id: 9, name: '섹시게이밍', vendor: 'Sexy Gaming', img: require('@/assets/img/casino/sexygaming.jpg') },
        { product_id: 10, name: '프라그마틱 플레이', vendor: 'Pragmatic', img: require('@/assets/img/casino/pragmaticplay.jpg') },
        { product_id: 15, name: 'TVBet', vendor: 'TVBet', img: require('@/assets/img/casino/tvbet.jpg') },
        { product_id: 17, name: '에즈기', vendor: 'Ezugi', img: require('@/assets/img/casino/ezugi.jpg') },
        { product_id: 18, name: '보타', vendor: 'Bota', img: require('@/assets/img/casino/bota.jpg'), noIframe: true },
        { product_id: 19, name: '스카이윈드', vendor: 'Skywind', img: require('@/assets/img/casino/skywind.jpg') },
        { product_id: 22, name: '두윈', vendor: 'Dowin', img: require('@/assets/img/casino/dowin.jpg'), noIframe: true },
        { product_id: 24, name: '오리엔탈 게이밍', vendor: 'Oriental', img: require('@/assets/img/casino/oriental.png') },
        { product_id: 30, name: '아이코닉21', vendor: 'Iconic21', img: require('@/assets/img/casino/iconic21.png') },
        { product_id: 35, name: 'XPG', vendor: 'XPG', img: require('@/assets/img/casino/xpg.png') },
        { product_id: 38, name: 'DB', vendor: 'DB', img: require('@/assets/img/casino/db.png') },
        { product_id: 39, name: '힐튼', vendor: 'Hilton', img: require('@/assets/img/casino/hilton.png'), noIframe: true },
      ]
    };
  },
  computed: {
    isMobile() {
      return this.$store.state.page.isMobile;
    },
    menuVisible() {
      return this.$store.getters['MENU_VISIBLE'];
    },
    liveCasinoVisible() {
      if (!Array.isArray(this.menuVisible)) return true;
      const display = this.menuVisible.find(e => e.name === '라이브카지노');
      return !display || display.visible !== false;
    },
    filteredGames() {
      return this.games.filter(game => {
        const matchesVendor = this.selectedVendor === 'all' || game.vendor === this.selectedVendor;
        const matchesSearch = game.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                             game.vendor.toLowerCase().includes(this.searchQuery.toLowerCase());
        return matchesVendor && matchesSearch;
      });
    }
  },
  watch: {
    liveCasinoVisible(visible) {
      if (visible === false) this.blockLiveCasino();
    }
  },
  mounted() {
    this.blockLiveCasinoIfHidden();
  },
  methods: {
    blockLiveCasinoIfHidden() {
      if (this.liveCasinoVisible) return false;
      this.blockLiveCasino();
      return true;
    },
    blockLiveCasino() {
      this.gameUrl = null;
      this.currentGameName = '';
      this.$router.push({ path: '/main' }).catch(() => {});
      this.$store.dispatch('SHOW_ERR_MSG3', '라이브 카지노는 점검중입니다.');
    },
    handleImageError(e) {
      e.target.src = '/img/casino/default.png';
    },
    async openGame(game) {
      if (this.blockLiveCasinoIfHidden()) return;

      if (!this.$store.state.user?.user) {
        return this.$store.dispatch('SHOW_ERR_MSG', '로그인이 필요합니다.');
      }

      try {
        const params = {
          domain_url: window.location.protocol + "//" + window.location.host,
          product_id: game.product_id,
          type: 0,
          is_mobile: this.isMobile ? 1 : 0
        };

        const response = await this.$store.dispatch('GET_KPLAY_GAME', params);

        if (response.data && response.data.url) {
          window.open(
            response.data.url,
            'game_window',
            `width=${screen.width},height=${screen.height},left=0,top=0,scrollbars=yes,resizable=yes`
          );
        } else {
          this.$store.dispatch('SHOW_ERR_MSG', '게임을 불러올 수 없습니다.');
        }
      } catch (error) {
        console.error('Game launch error:', error);
        this.$store.dispatch('SHOW_ERR_MSG', '게임 실행 중 오류가 발생했습니다.');
      }
    },
    closeGame() {
      this.gameUrl = null;
      this.currentGameName = '';
    }
  }
};
</script>

<style scoped>
.kplay-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
  min-height: 100vh;
  /* background: #252b2b; */
}

.kplay-header {
  margin-bottom: 30px;
}

.kplay-title {
  color: #D4AF37;
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 20px;
  text-align: center;
}

.kplay-filter {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin-bottom: 20px;
}

.filter-btn {
  padding: 10px 20px;
  border: 1px solid #D4AF37;
  background: transparent;
  color: #D4AF37;
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.filter-btn:hover,
.filter-btn.active {
  background: #D4AF37;
  color: #1a1a2e;
}

.kplay-search {
  display: flex;
  justify-content: center;
}

.search-input {
  width: 100%;
  max-width: 400px;
  padding: 12px 20px;
  border: 1px solid #3a4040;
  background: #1e2323;
  color: #fff;
  border-radius: 25px;
  font-size: 14px;
  outline: none;
}

.search-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.search-input:focus {
  border-color: #D4AF37;
  background: #1e2323;
}

.games-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.game-card {
  background: #1e2323;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #3a4040;
}

.game-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.5);
  border-color: #D4AF37;
}

.game-thumbnail {
  position: relative;
  width: 100%;
  padding-top: 100%; /* 1:1 정사각형 */
  overflow: hidden;
}

.game-thumbnail img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #1a1f1f;
}

.game-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.game-card:hover .game-overlay {
  opacity: 1;
}

.play-btn {
  padding: 12px 30px;
  background: linear-gradient(135deg, #D4AF37 0%, #FFA500 100%);
  border: none;
  border-radius: 25px;
  color: #1a1a2e;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.play-btn:hover {
  transform: scale(1.1);
}

.game-info {
  padding: 15px;
}

.game-name {
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 5px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.game-vendor {
  color: #D4AF37;
  font-size: 12px;
}

.no-games {
  text-align: center;
  color: #999;
  padding: 50px;
  font-size: 18px;
}

/* Tablet: 3 columns */
@media (max-width: 1200px) {
  .games-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

/* Mobile: 2 columns */
@media (max-width: 768px) {
  .kplay-container {
    padding: 15px;
  }

  .kplay-title {
    font-size: 22px;
  }

  .games-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }

  .filter-btn {
    padding: 8px 15px;
    font-size: 12px;
  }

  .game-info {
    padding: 10px;
  }

  .game-name {
    font-size: 12px;
  }

  .game-vendor {
    font-size: 10px;
  }
}

/* Small mobile: 2 columns */
@media (max-width: 480px) {
  .games-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }

  .kplay-filter {
    gap: 6px;
  }

  .filter-btn {
    padding: 6px 12px;
    font-size: 11px;
  }

  .game-info {
    padding: 8px;
  }

  .game-name {
    font-size: 11px;
  }

  .game-vendor {
    font-size: 9px;
  }
}

/* Game Iframe Styles */
.game-iframe-container {
  width: 100%;
  height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
}

.game-iframe-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  background: #1e2323;
  border-bottom: 1px solid #3a4040;
}

.game-title {
  color: #D4AF37;
  font-size: 18px;
  font-weight: 700;
}

.close-btn {
  padding: 10px 20px;
  background: #D4AF37;
  border: none;
  border-radius: 5px;
  color: #1a1a2e;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.3s ease;
}

.close-btn:hover {
  background: #FFEC8B;
}

.game-iframe {
  flex: 1;
  width: 100%;
  border: none;
  background: #000;
}

@media (max-width: 768px) {
  .game-iframe-container {
    height: calc(100vh - 80px);
  }

  .game-iframe-header {
    padding: 10px 15px;
  }

  .game-title {
    font-size: 14px;
  }

  .close-btn {
    padding: 8px 15px;
    font-size: 12px;
  }
}
</style>
